import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  HomeOutlined,
  FileTextOutlined,
  HolderOutlined,
  LogoutOutlined,
  MenuOutlined,
  PayCircleOutlined,
  PrinterOutlined,
  SolutionOutlined,
  UserOutlined,
  UserSwitchOutlined,
  ShopOutlined,
  ProfileOutlined,
} from '@ant-design/icons';
import { MenuProps } from 'antd';
import { useLogout, userSelector } from '~/App/store/auth';
import { useRecoilValue } from 'recoil';

export const getMenuFromPath = (rawPath: string) => {
  const path = rawPath.split('/').filter((val) => val);
  if (!path.length) {
    return {
      root: 'home',
      key: 'home',
    };
  }
  return {
    root: path[0],
    key: path.length > 1 ? path.join('/') : `${path[0]}/`,
  };
};

export const useSystemNavItems = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(userSelector);

  return useMemo(() => {
    return [
      {
        key: 'home',
        icon: <HomeOutlined />,
        label: 'Home',
        onClick: () => navigate('/'),
      },
      // {
      //   key: 'restaurant',
      //   icon: <ShopOutlined />,
      //   label: 'Restaurant',
      //   onClick: () => navigate('/restaurant-settings'),
      // },
      ...(user?.isInternal
        ? [
            {
              key: 'user',
              icon: <UserOutlined />,
              label: 'User',
              onClick: () => navigate('/user'),
            },
          ]
        : []),
    ];
  }, []);
};

export const useRestaurantNavItems = () => {
  const _navigate = useNavigate();
  const navigate = (path: string) => {
    _navigate(`/restaurant${path}`);
  };
  const logout = useLogout();

  return useMemo(
    () =>
      [
        {
          key: 'category',
          icon: <HolderOutlined />,
          label: 'Categories',
          onClick: () => navigate('/categories'),
        },
        {
          key: 'menu',
          icon: <MenuOutlined />,
          label: 'Menus',
          onClick: () => navigate('/menus'),
        },
        {
          key: 'order/',
          icon: <ProfileOutlined />,
          label: 'Order',
          onClick: () => navigate('/order'),
        },
        {
          key: 'report/',
          icon: <FileTextOutlined />,
          label: 'Reports',
          onClick: () => navigate('/report'),
        },
        {
          key: 'payment-account/',
          icon: <PayCircleOutlined />,
          label: 'Payment Account',
          onClick: () => navigate('/payment-account'),
        },
        {
          key: 'price-rounding/',
          icon: <PayCircleOutlined />,
          label: 'Price Rounding',
          onClick: () => navigate('/price-rounding'),
        },
        {
          key: 'print-server/',
          icon: <PrinterOutlined />,
          label: 'Print Server',
          onClick: () => navigate('/print-server'),
        },
        {
          key: 'printer/',
          icon: <PrinterOutlined />,
          label: 'Printer',
          onClick: () => navigate('/printer'),
        },
        {
          key: 'role/',
          icon: <SolutionOutlined />,
          label: 'Role',
          onClick: () => navigate('/role'),
        },
        {
          key: 'user-role/',
          icon: <UserSwitchOutlined />,
          label: 'User Role Setting',
          onClick: () => navigate('/user-role'),
        },
        {
          key: 'logout',
          icon: <LogoutOutlined />,
          label: 'Logout',
          onClick: () => {
            logout();
          },
        },
      ] as MenuProps['items'],
    []
  );
};
